/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { Modal } from "react-bootstrap";
import React, { useState } from "react";

function SuccessModal({ open, removeModal, successFailureMessage }) {
  return (
    <div>
      <Modal
        show={open === "dismissible"}
        size="md"
        onClose={() => removeModal()}
        zIndex="1000"
        centered
      >
        <Modal.Body className="p-0 rounded-[8px]">
          <div className="flex justify-center items-center bg-[#54BD3A] py-3">
            <svg className="icon text-[white] text-[50px]">
              <use href="#icon_success"></use>
            </svg>
          </div>
          <div className="p-4 py-8">
            <h3 className="text-center font-bold text-[26px]">Great!</h3>
            <p className="text-center font-bold text-[20px] text-[#7D7D7D]">
              {successFailureMessage}
            </p>
            <div className="pt-4 flex justify-center">
              <button
                type="button"
                className="flex w-[180px] items-center text-center justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-[#54BD3A] text-white  hover:bg-[#4E9D3A]"
                onClick={() => removeModal()}
              >
                OKAY
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default SuccessModal;
